import { UserProfession, UserSubProfession } from '../../../../../enums/UserProfession';
import { Colors } from '../../../../../themes/colors';

/**
 * Helper to render info row in confirmation modal
 */
const renderConfirmRow = (label, value) => (
  <div
    style={{
      margin: 5,
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: 18,
      gap: 8,
    }}
  >
    <strong>{label}</strong>
    <span style={{ textAlign: 'end' }}>{value}</span>
  </div>
);

export const ConfirmationModal = ({
  isOpen,
  previewData,
  office,
  onConfirm,
  onCancel,
  isSubmitting,
}) => {
  if (!isOpen) return null;

  const officeName = office?.officeName || office?.office_name || 'Selected Office';

  // Sort preview data by date in ascending order
  const sortedPreviewData = [...previewData].sort((a, b) => a.localDate.localeCompare(b.localDate));

  return (
    <div className="modal">
      <div
        className="modal_content"
        style={{
          width: '900px',
          marginTop: 20,
          padding: 20,
        }}
      >
        {/* Modal Title */}
        <h3
          style={{
            fontSize: '18px',
            textAlign: 'center',
            marginBottom: 20,
            marginTop: 50,
          }}
        >
          Please Confirm Onsite Interviews
          <br />
          <br />
          <strong>{officeName}</strong>
        </h3>

        {/* Interview Slots Grid */}
        <div
          style={{
            padding: 30,
            overflowY: 'auto',
            maxHeight: 600,
            width: '90%',
            alignItems: 'center',
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
          }}
        >
          {sortedPreviewData.map((interview) => (
            <div
              key={interview.localDate}
              style={{
                margin: 10,
                borderRadius: 20,
                boxShadow: '0px 1px 3px 1px rgba(0, 0, 0, 0.15)',
                padding: 10,
                width: '300px',
                alignSelf: 'center',
              }}
            >
              {renderConfirmRow('Date: ', interview.localDate)}
              {renderConfirmRow('Hours: ', `${interview.localStart} - ${interview.localEnd}`)}
              {renderConfirmRow('Rate: ', interview.rate)}
              {renderConfirmRow(
                'Meal Break: ',
                `${interview.breakTime} (${interview.isBreakPaid ? 'Paid' : 'Unpaid'})`,
              )}
              {renderConfirmRow(
                'Profession: ',
                UserSubProfession.getName(interview.subProfession) ??
                  UserProfession.getName(interview.profession),
              )}
              {renderConfirmRow('Preferred Skill: ', interview.specialty?.split('_')?.[1])}
            </div>
          ))}
        </div>

        {/* Action Buttons */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 20,
            gap: 20,
          }}
        >
          <button
            type="button"
            className="btn"
            onClick={onCancel}
            disabled={isSubmitting}
            style={{
              width: 200,
              borderRadius: 50,
              height: 50,
              fontSize: 20,
              marginRight: 40,
              backgroundColor: Colors.secondary_500,
              color: Colors.white,
              border: 'none',
              opacity: isSubmitting ? 0.6 : 1,
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn"
            onClick={onConfirm}
            disabled={isSubmitting}
            style={{
              width: 200,
              borderRadius: 50,
              height: 50,
              fontSize: 20,
              backgroundColor: Colors.primary_500,
              color: Colors.white,
              border: 'none',
              opacity: isSubmitting ? 0.6 : 1,
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
            }}
          >
            {isSubmitting ? (
              <div
                className="spinner-border spinner-border-sm"
                role="status"
                style={{ width: 20, height: 20 }}
              />
            ) : (
              'Confirm'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
